<div class="service-commitment-container" [formGroup]="formGroup">

  <div class="section-card">

    <!-- Not Applicable Checkbox -->
    <div class="checkbox-row mb-3">
      <mat-checkbox formControlName="section">
        Check this if this section is <u>not applicable</u> to you.(Optional)
      </mat-checkbox>
    </div>

    <!-- Radio Buttons -->
    <div class="mb-3">
      <mat-label class="radio-label">Service Status:</mat-label>
      <mat-radio-group formControlName="status" class="d-flex flex-wrap gap-3">
        <mat-radio-button value="completed">Completed</mat-radio-button>
        <mat-radio-button value="deferred">Deferred</mat-radio-button>
        <mat-radio-button value="exempted">Exempted</mat-radio-button>
      </mat-radio-group>
      @if(this.formGroup.controls["status"].invalid
      && (this.formGroup.controls["status"].touched ||
      this.formGroup.controls["status"].dirty)
      ) {
      <mat-error>
        @if(this.formGroup.controls["status"].errors?.["required"]) {
        <span>{{message}}</span>
        }
        @else {
        <span></span>
        }
      </mat-error>
      }
    </div>

    @if(this.formGroup.get('status')?.value === 'deferred' || this.formGroup.get('status')?.value === 'exempted' ){
    <div class="col-md-6">
      <mat-label class="field-label">Attachment</mat-label>
      <div class="upload-container">
        <div class="upload-box">
          <input type="file" id="attachment_servicecommitementfileName" accept=".pdf,.jpg,.jpeg,.png"
            [disabled]="readonly()" (change)="onAttachmentServiceCommitmentFileChange($event)">
          <input type="text" formControlName="attachment_servicecommitementfileName" hidden>

          <!-- Show filename OR placeholder -->
          @if(!this.formGroup.get('attachment_servicecommitementfileName')?.value){
          <span>
            Choose file
          </span>
          }
          @if(this.formGroup.get('attachment_servicecommitementfileName')?.value){
          <div class="attachment-row">
            <span class="file-name">
              {{ this.formGroup.get('attachment_servicecommitementfileName')?.value }}
            </span>
            @if(readonly() === false){
            <button mat-icon-button color="primary" class="delete-btn"
              (click)="removeFile('attachment_servicecommitementfileName','attachment_servicecommitement','Attachement(NationalServie Commitment)')">
              <mat-icon>close</mat-icon>
            </button>
            }
            <button mat-icon-button color="primary" class="delete-btn"
                (click)="previewAttachment('attachment_servicecommitementfileName','Attachement(NationalServie Commitment)')">
                <mat-icon>visibility</mat-icon>
            </button>
          </div>
          }
        </div>
      </div>
      @if(this.formGroup.controls["attachment_servicecommitementfileName"].invalid
      && (this.formGroup.controls["attachment_servicecommitementfileName"].touched ||
      this.formGroup.controls["attachment_servicecommitementfileName"].dirty)
      ) {
      <mat-error>
        @if(this.formGroup.controls["attachment_servicecommitementfileName"].errors?.["required"]) {
        <span>{{message}}</span>
        }@else if(this.formGroup.controls["attachment_servicecommitementfileName"].errors?.['invalidType']){
        <span>Only PDF, JPG, PNG files are allowed.</span>
        }
        @else if(this.formGroup.controls["attachment_servicecommitementfileName"].errors?.['maxSize']){
        <span>File size must be less than or equal to 5MB.</span>
        }
        @else {
        <span></span>
        }
      </mat-error>
      }
    </div>
    }

    <!-- Date Fields -->
    <div class="row g-3">

      <!-- Enlistment Date -->
      <div class="col-md-6">
        <mat-label class="field-label">Enlistment Date</mat-label>
        <mat-form-field class="w-100">
          <input matInput formControlName="enlistment" [matDatepicker]="picker1" placeholder="MM/YYYY">
          <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1 startView="multi-year" (monthSelected)="setenlistmentMonthAndYear($event, picker1)"
            panelClass="month-picker"></mat-datepicker>
          @if(this.formGroup.controls["enlistment"].invalid
          && (this.formGroup.controls["enlistment"].touched ||
          this.formGroup.controls["enlistment"].dirty)
          ) {
          <mat-error>
            @if(this.formGroup.controls["enlistment"].errors?.["required"]) {
            <span>{{message}}</span>
            }
            @else {
            <span></span>
            }
          </mat-error>
          }
        </mat-form-field>
      </div>

      <!-- ORD Date -->
      <div class="col-md-6">
        <mat-label class="field-label">ORD Date</mat-label>
        <mat-form-field class="w-100">
          <input matInput formControlName="ord" [matDatepicker]="picker2"  placeholder="MM/YYYY">
          <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2 startView="multi-year" (monthSelected)="setordMonthAndYear($event, picker2)"
            panelClass="month-picker"></mat-datepicker>
          @if(this.formGroup.controls["ord"].invalid
          && (this.formGroup.controls["ord"].touched ||
          this.formGroup.controls["ord"].dirty)
          ) {
          <mat-error>
            @if(this.formGroup.controls["ord"].errors?.["required"]) {
            <span>{{message}}</span>
            }
            @else {
            <span></span>
            }
          </mat-error>
          }
        </mat-form-field>
      </div>

    </div>

  </div>

</div>
@if(readonly() === false){
<!-- Form Actions -->
<div class="form-actions">
  <button mat-raised-button color="primary" class="save-btn" (click)="saveAndContinue()">

    <span>Save & Continue</span>
    <mat-icon>arrow_forward</mat-icon>

  </button>
</div>
}